import React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import { ButtonVariant } from "../misc";

import styles from "./StdButton.module.scss";
interface StdButtonProps extends ButtonProps {
    variant?: ButtonVariant;
}

export const StdButton: React.FC<StdButtonProps> = props => {
    const { className, children, variant, ...buttonProps } = props;
    let _variant = variant == null ? "std" : variant;

    return (
        <Button className={` ${className ?? ""} ${styles.button}`} {...buttonProps} variant={_variant}>
            {children}
        </Button>
    );
};
